var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuitAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4265_9747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8678 12.6257L13.1082 11.0339C13.0404 11 12.9389 11 12.8711 11.0339C12.8033 11.0678 12.7356 11.1355 12.7356 11.2033L10.534 20.1113L8.2985 11.2033C8.26459 11.1355 8.23069 11.0678 8.16305 11.0339C8.09524 11 8.0276 11 7.92588 11.0339L4.20008 12.4564C3.69201 12.6597 3.38721 13.0662 3.38721 13.5403V21.2291C3.38721 21.3646 3.52266 21.5 3.65811 21.5H10.3986H10.5679H17.3082C17.4437 21.5 17.5791 21.3985 17.5791 21.2291V13.7097C17.6469 13.2694 17.3421 12.829 16.8678 12.6257Z",
    fill: "#06CEA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7194 11.8129C11.8888 11.542 11.8549 11.1694 11.6177 10.9322C11.4823 10.7628 11.279 10.6952 11.042 10.6952H10.0259C9.82262 10.6952 9.58546 10.7967 9.45001 10.9322C9.24675 11.1694 9.1791 11.5081 9.34846 11.8129L9.61936 12.2194C9.75481 12.4564 9.82262 12.6935 9.78871 12.9644L9.61936 14.7258L10.1274 16.1145C10.1952 16.2839 10.3307 16.3854 10.5339 16.3854C10.7372 16.3854 10.8727 16.2839 10.9403 16.1145L11.4484 14.7258L11.2453 12.9984C11.2114 12.7274 11.279 12.4564 11.4146 12.2533L11.7194 11.8129Z",
    fill: "#06CEA8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 9.91606C12.7693 9.91606 14.5983 8.08706 14.5983 5.85155V4.56452C14.5983 2.329 12.7693 0.5 10.5338 0.5C8.29824 0.5 6.46924 2.329 6.46924 4.56452V5.85155C6.46924 8.08706 8.29824 9.91606 10.5338 9.91606Z",
    fill: "#06CEA8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4265_9747"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuitAvatar);
export default __webpack_public_path__ + "static/media/suit-avatar.3f3bbcf72cc9ecf7f4553fb75ce73809.svg";
export { ForwardRef as ReactComponent };